import { render, staticRenderFns } from "./robotView2.vue?vue&type=template&id=c291dbe8&scoped=true"
import script from "./robotView2.vue?vue&type=script&lang=js"
export * from "./robotView2.vue?vue&type=script&lang=js"
import style0 from "./robotView2.vue?vue&type=style&index=0&id=c291dbe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c291dbe8",
  null
  
)

export default component.exports